import { useEffect, useState } from "react";
import {
  getStorage,
  ref,
  listAll,
  getDownloadURL
} from "firebase/storage";
import { Link } from "react-router-dom";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [loadedCount, setLoadedCount] = useState(0);
  const IMAGES_PER_PAGE = 12;
  const storage = getStorage();
  const [lightboxImage, setLightboxImage] = useState(null);

  useEffect(() => {
    loadImages();
    document.title = "Christa & Dan's Wedding Gallery";
  }, []);

  const loadImages = async () => {
    if (loading) return;
    setLoading(true);

    const baseRef = ref(storage, "wedding-uploads");
    const allUsers = await listAll(baseRef);
    let tempImages = [];

    for (const userFolder of allUsers.prefixes) {
      const uploader = userFolder.name;
      const userFiles = await listAll(userFolder);

      for (const fileRef of userFiles.items) {
        const url = await getDownloadURL(fileRef);
        tempImages.push({ url, uploader, timestamp: fileRef.name.split('-')[0] });
      }
    }

    tempImages.sort((a, b) => b.timestamp - a.timestamp); // newest first

    const nextBatch = tempImages.slice(loadedCount, loadedCount + IMAGES_PER_PAGE);
    setImages((prev) => [...prev, ...nextBatch]);
    setLoadedCount(loadedCount + nextBatch.length);
    setHasMore(loadedCount + nextBatch.length < tempImages.length);
    setLoading(false);
  };

  return (
    <div className="gallery-page">
      <h1>Wedding Gallery</h1>
      <Link to="/" className="gallery-link">← Back to Upload</Link>
  
      <div className="gallery-grid">
        {images.length === 0 && loading && <p>Loading photos...</p>}
        {images.length === 0 && !loading && <p>No photos uploaded yet.</p>}
        {images.map((img, index) => (
          <div key={index} className="gallery-item">
            <img
              src={img.url}
              alt={`Upload by ${img.uploader}`}
              onClick={() => setLightboxImage(img)}
              style={{ cursor: "pointer" }}
            />
            <p className="uploader-name">— {img.uploader}</p>
          </div>
        ))}
      </div>
  
      {hasMore && (
        <button onClick={loadImages} className="load-more-btn">
          {loading ? "Loading..." : "Load More"}
        </button>
      )}
  
      {lightboxImage && (
        <div className="lightbox" onClick={() => setLightboxImage(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={lightboxImage.url} alt="Full View" />
            <p className="uploader-name">— {lightboxImage.uploader}</p>
          </div>
        </div>
      )}
    </div>
  );
}  